import React, { useState } from 'react';
import macPrintWindow from '../../assets/images/print/mac-print-window.png';
import ModalModule from '../modal';
import UI from '../ui';

const { Modal, ModalButtonActionType } = ModalModule;
const { WrappedCheckbox } = UI;

const SafariWarningMessageModal = ({ modalId, data: { callback } }) => {
	const [dismissSafariPrintWarning, setDismissSafariPrintWarning] = useState(
		localStorage.getItem('dismissSafariPrintWarning') === 'true'
	);

	const onClickCheckbox = ({ target: { checked } }) => {
		setDismissSafariPrintWarning(checked);
		localStorage.setItem('dismissSafariPrintWarning', checked);
	};

	return (
		<Modal
			modalId={modalId}
			className="safari-warning-message"
			header="Attention Safari Users"
			primaryButton={{
				type: ModalButtonActionType.Confirm,
				text: 'Continue',
				onClick: () => {
					callback(modalId);
				},
			}}
		>
			<div className="p-col-12">
				<p>
					To ensure your labels print correctly when using Safari, please
					uncheck the "print headers and footers" box on the next screen.
				</p>
				<img src={macPrintWindow} alt="Mac Print Window" />
				<WrappedCheckbox
					inputId="safariWarningCheckbox"
					name="hideWarning"
					value={dismissSafariPrintWarning}
					onChange={onClickCheckbox}
					checked={dismissSafariPrintWarning}
					htmlFor="safariWarningCheckbox"
					dataqa="safari-warning-message"
				>
					Don't show this again
				</WrappedCheckbox>
			</div>
		</Modal>
	);
};

export default SafariWarningMessageModal;
